module.exports = __webpack_public_path__ + "statics/img/1.17da22b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/1.png
// module id = AJbr
// module chunks = 1